import { inject, Injectable } from '@angular/core';
import { appWidgetStateToConfig, DashboardService } from '@ddv/dashboards';
import { QueryParamsService } from '@ddv/filters';
import { ManagerService, setWidgetExtraParamsFromDashboardDetails } from '@ddv/layout';
import { DashboardPreference, Mode } from '@ddv/models';

@Injectable()
export class RevertDashboardService {
    private readonly dashboardService = inject(DashboardService);
    private readonly manager = inject(ManagerService);
    private readonly queryParamsService = inject(QueryParamsService);

    revert(dashboardId: string, workspaceMode: Mode, clientCode: string): void {
        this.dashboardService.fetchDashboard(clientCode, Number(dashboardId))
            .subscribe((dashboard) => {
                if (this.manager.getCurrentDashboardId() !== dashboard.id?.toString()) {
                    return;
                }

                const workspace = this.manager.getWorkspace();
                if (!workspace) {
                    return console.error('Cannot revert without a workspace');
                }
                setWidgetExtraParamsFromDashboardDetails(dashboard, workspace);

                const extraParams = workspace.getExtraParameters();

                const defaultQueryParams: DashboardPreference = { funds: [], filters: [] };
                const queryParams = extraParams?.dashboardPreference;

                this.queryParamsService.dispatchNewQueryParams(queryParams ?? defaultQueryParams);

                this.manager.createWidgets(appWidgetStateToConfig(extraParams?.widgets, workspaceMode));
            });
    }
}
